import { Component, OnInit } from '@angular/core';
import {ModalController} from "@ionic/angular";
import {ChooseDoctorListModalComponent} from "../choose-doctor-list-modal/choose-doctor-list-modal.component";
import {NotificationPanelComponent} from "../notification-panel/notification-panel.component";

@Component({
  selector: 'app-notification-badge',
  templateUrl: './notification-badge.component.html',
  styleUrls: ['./notification-badge.component.scss'],
})
export class NotificationBadgeComponent implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() {}
  openNotificationPanel(){
    this.modalController.create({component:NotificationPanelComponent,id:"NotificationPanelModal" }).then((modalElement)=>
        {
          modalElement.present();
        }
    )
  }
  dismiss(){
    this.modalController.dismiss();
  }

}
